/**
 * For future use other countries GeoJson data can be found here
 * https://github.com/johan/world.geo.json
 */
export const COUNTRIES = {
  england: {
    coordinates: [-1.42154, 54.712928],
    tileset: require('./geoJson/GBR.geo.json'),
    flag: require('../../images/flags/britain.png'),
  },
  usa: {
    coordinates: [-104.015355, 38.026188],
    tileset: require('./geoJson/USA.geo.json'),
    flag: require('../../images/flags/usa.svg'),
  },
  'south africa': {
    coordinates: [23.513941, -29.731291],
    tileset: require('./geoJson/ZAF.geo.json'),
    flag: require('../../images/flags/sa.jpg'),
  },
  australia: {
    coordinates: [148.558156, -23.785133],
    tileset: require('./geoJson/AUS.geo.json'),
    flag: require('../../images/flags/aus.svg'),
  },
  phillipines: {
    coordinates: [121.487844, 13.859638],
    tileset: require('./geoJson/PHL.geo.json'),
    flag: require('../../images/flags/phillipines.webp'),
  },
  wales: {
    coordinates: [-1.42154, 54.712928],
    tileset: require('./geoJson/GBR.geo.json'),
    flag: require('../../images/flags/wales.png'),
  },
  'sri lanka': {
    coordinates: [80.783492, 7.137065],
    tileset: require('./geoJson/LKA.geo.json'),
    flag: require('../../images/flags/sri.webp'),
  },
  mauritius: {
    coordinates: [55.55463, -21.051334],
    tileset: require('./geoJson/MAU.geo.json'),
    flag: require('../../images/flags/mau.svg'),
  },
  iceland: {
    coordinates: [-19.286231, 64.298511],
    tileset: require('./geoJson/ISL.geo.json'),
    flag: require('../../images/flags/iceland.svg'),
  },
  jamaica: {
    coordinates: [-77.484979, 18.188986],
    tileset: require('./geoJson/JAM.geo.json'),
    flag: require('../../images/flags/jamica.svg'),
  },
  'jewish (poland)': {
    coordinates: [20.266834, 52.029756],
    tileset: require('./geoJson/POL.geo.json'),
    flag: require('../../images/flags/poland.png'),
  },
  germany: {
    coordinates: [10.440371, 50.774709],
    tileset: require('./geoJson/DEU.geo.json'),
    flag: require('../../images/flags/ger.png'),
  },
  japan: {
    coordinates: [139.470129, 36.735748],
    tileset: require('./geoJson/JPN.geo.json'),
    flag: require('../../images/flags/japan.png'),
  },
  trinidad: {
    coordinates: [-61.237824, 10.456282],
    tileset: require('./geoJson/TTO.geo.json'),
    flag: require('../../images/flags/taandt.svg'),
  },
  sinhalese: {
    coordinates: [80.783492, 7.137065],
    tileset: require('./geoJson/LKA.geo.json'),
    flag: require('../../images/flags/sri.webp'),
  },
  'indian tamil': {
    coordinates: [76.920156, 10.747789],
    tileset: require('./geoJson/IND.geo.json'),
    flag: require('../../images/flags/india.webp'),
  },
  tunisia: {
    coordinates: [9.559086, 34.651537],
    tileset: require('./geoJson/TUN.geo.json'),
    flag: require('../../images/flags/tunisia.svg'),
  },
  grenada: {
    coordinates: [-61.689185, 12.133591],
    tileset: require('./geoJson/Grenada.geo.json'),
    flag: require('../../images/flags/grenada.svg'),
  },
  'puerto rico': {
    coordinates: [-66.349344, 18.250002],
    tileset: require('./geoJson/PRI.geo.json'),
    flag: require('../../images/flags/puertorico.svg'),
  },
  mexico: {
    coordinates: [-102.317032, 24.445461],
    tileset: require('./geoJson/MEX.geo.json'),
    flag: require('../../images/flags/mexico.svg'),
  },
};

/** City-level birth places — map zooms here when the Prismic birth field mentions the city */
const CITY_BIRTH_LOCATIONS = {
  baguio: {
    coordinates: [120.5937, 16.4023],
    birthZoom: 6.5,
    countryKey: 'phillipines',
  },
  benguet: {
    coordinates: [120.5937, 16.4023],
    birthZoom: 6.5,
    countryKey: 'phillipines',
  },
  'oriental mindoro': {
    coordinates: [121.1806, 13.4117],
    birthZoom: 7.2,
    countryKey: 'phillipines',
  },
  'occidental mindoro': {
    coordinates: [120.7651, 13.1024],
    birthZoom: 7.2,
    countryKey: 'phillipines',
  },
  mindoro: {
    coordinates: [121.1806, 13.4117],
    birthZoom: 7,
    countryKey: 'phillipines',
  },
};

/** Mapbox country filter so misspelled CMS text still geocodes inside the right country */
const COUNTRY_ISO = {
  england: 'gb',
  wales: 'gb',
  usa: 'us',
  'south africa': 'za',
  australia: 'au',
  phillipines: 'ph',
  'sri lanka': 'lk',
  mauritius: 'mu',
  iceland: 'is',
  jamaica: 'jm',
  'jewish (poland)': 'pl',
  germany: 'de',
  japan: 'jp',
  trinidad: 'tt',
  sinhalese: 'lk',
  'indian tamil': 'in',
  tunisia: 'tn',
  grenada: 'gd',
  'puerto rico': 'pr',
  mexico: 'mx',
};

const geocodeMapboxPlace = async (placeText, countryIso) => {
  const token = process.env.GATSBY_MAPBOX_API_KEY;
  if (!token || !placeText) return null;

  const query = String(placeText)
    .replace(/\bphillipines\b/gi, 'Philippines')
    .replace(/\s+/g, ' ')
    .trim();
  if (!query) return null;

  try {
    const params = new URLSearchParams({
      access_token: token,
      limit: '1',
      types: 'place,locality,district,region,poi',
    });
    if (countryIso) params.set('country', countryIso);

    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?${params}`;
    const res = await fetch(url);
    if (!res.ok) return null;
    const data = await res.json();
    const center = data?.features?.[0]?.center;
    return Array.isArray(center) && center.length === 2 ? center : null;
  } catch {
    return null;
  }
};

const findCityBirthKey = (normalized) => {
  const compact = normalized.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
  const primarySegment = compact.split(' ')[0] || compact;
  const keys = Object.keys(CITY_BIRTH_LOCATIONS).sort((a, b) => b.length - a.length);
  return keys.find((key) => compact.includes(key) || primarySegment.includes(key));
};

const normalizeBirthLocationText = (text) =>
  String(text || '')
    .toLowerCase()
    .replace(/\bphilippines\b/g, 'phillipines');

const resolveCountryKeyFromBirthText = (birthText) => {
  const normalized = normalizeBirthLocationText(birthText);
  if (!normalized) return null;

  const keys = Object.keys(COUNTRIES).sort((a, b) => b.length - a.length);
  return keys.find((key) => normalized.includes(key)) || null;
};

/** Match a COUNTRIES entry from free-text birth location (e.g. "Baguio … Phillipines") */
const resolveCountryFromBirthText = (birthText) => {
  const countryKey = resolveCountryKeyFromBirthText(birthText);
  return countryKey ? COUNTRIES[countryKey] : null;
};

/** Prismic country label (family origin, current country, etc.) → COUNTRIES entry */
const resolveCountryByLabel = (text) => {
  const normalized = normalizeBirthLocationText(text).trim();
  if (!normalized) return null;
  if (COUNTRIES[normalized]) return COUNTRIES[normalized];
  return resolveCountryFromBirthText(text);
};

const getCountryFlagSrc = (country) => country?.flag?.default ?? country?.flag ?? null;

/**
 * Birth map target: city coordinates when known, otherwise country center.
 * Returns { coordinates, tileset, flag, birthZoom } for IndividualMap.
 */
const resolveBirthLocation = (birthText) => {
  const normalized = normalizeBirthLocationText(birthText);
  if (!normalized) return null;

  const cityKey = findCityBirthKey(normalized);
  if (cityKey) {
    const city = CITY_BIRTH_LOCATIONS[cityKey];
    const country = COUNTRIES[city.countryKey];
    if (!country) return null;
    return {
      coordinates: city.coordinates,
      tileset: country.tileset,
      flag: country.flag,
      birthZoom: city.birthZoom,
      isCity: true,
    };
  }

  const country = resolveCountryFromBirthText(birthText);
  if (!country) return null;

  return {
    coordinates: country.coordinates,
    tileset: country.tileset,
    flag: country.flag,
    birthZoom: 6.8,
    isCity: false,
  };
};

/** Async resolver: static city/country match, then Mapbox geocode for multi-part birth strings */
const resolveBirthLocationAsync = async (birthText) => {
  const sync = resolveBirthLocation(birthText);
  if (sync?.isCity) return sync;

  const normalized = normalizeBirthLocationText(birthText);
  const looksLikeAddress = Boolean(birthText && (String(birthText).includes(',') || findCityBirthKey(normalized)));

  if (looksLikeAddress) {
    const countryKey = resolveCountryKeyFromBirthText(birthText);
    const country = countryKey ? COUNTRIES[countryKey] : null;
    const countryIso = countryKey ? COUNTRY_ISO[countryKey] : undefined;
    const locality = String(birthText)
      .split(',')
      .map((part) => part.trim())
      .filter((part) => part && !/phill?ippines/i.test(part))
      .join(', ');

    const geocoded =
      (await geocodeMapboxPlace(locality || birthText, countryIso)) ||
      (await geocodeMapboxPlace(birthText, countryIso));

    if (geocoded && country) {
      return {
        coordinates: geocoded,
        tileset: country.tileset,
        flag: country.flag,
        birthZoom: 6.8,
        isCity: true,
      };
    }
  }

  return sync;
};

export {
  resolveBirthLocation,
  resolveBirthLocationAsync,
  resolveCountryFromBirthText,
  resolveCountryByLabel,
  getCountryFlagSrc,
};
